module.exports = __webpack_public_path__ + "static/media/blood-pressure.898fabd9.svg";